import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "calendarClock"
const CalendarClockIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M18 16.922 19.655 18.577 18.595 19.637 16.5 17.544V14.64H18z" />
          <path
            fillRule="evenodd"
            d="M17.25 10.875C20.77 10.875 23.625 13.729 23.625 17.25S20.771 23.625 17.25 23.625 10.875 20.771 10.875 17.25 13.729 10.875 17.25 10.875M17.25 12.375C14.558 12.375 12.375 14.558 12.375 17.25S14.558 22.125 17.25 22.125 22.125 19.942 22.125 17.25 19.942 12.375 17.25 12.375"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M8.25 3.75H15.75V1.5H17.25V3.75H20.25C21.078 3.75 21.75 4.422 21.75 5.25V11.25C21.289 10.902 20.785 10.61 20.25 10.375V9.75H3.75V18.75H9.9C10.006 19.272 10.168 19.773 10.376 20.25H3.75L3.597 20.242C2.84 20.165 2.25 19.527 2.25 18.75V5.25C2.25 4.422 2.922 3.75 3.75 3.75H6.75V1.5H8.25zM3.75 8.25H20.25V5.25H17.25V6.75H15.75V5.25H8.25V6.75H6.75V5.25H3.75z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default CalendarClockIcon
